import React from 'react';
import PageActions from '../../actions/page';
import SharedSource from '../../sources/shared';
import { addNotification } from '../../actions/reduxActions/notification';
import { notificationTypes } from '../../constants';
import store from '../../store/store';

/**
 * Make a duplicate of the current page with a new name
 *
 * @param {Object}   page the current page we wish to clone
 * @param {Boolean}  isDirty if the page has been modified
 * @param {String}   manywhoTenantId the tenant
 * @param {String}   authenticationToken the token
 */
const PageClone = ({ page, isDirty, manywhoTenantId, authenticationToken }) => {

    const nameInput = React.createRef();
    const labelInput = React.createRef();
    const summaryInput = React.createRef();

    const onSave = () => {
        const pageId = page.id.value;
        SharedSource.get(pageId, 'page', manywhoTenantId, authenticationToken)
            .then((response) => {
                const newPage = JSON.parse(response);

                newPage.id = null;
                newPage.developerName = nameInput.current.value;
                newPage.label = labelInput.current.value;
                newPage.developerSummary = summaryInput.current.value;
                return SharedSource.save(newPage, 'page', manywhoTenantId, authenticationToken);
            })
            .then((saveResponse) => {
                store.dispatch(addNotification({
                    type: notificationTypes.SUCCESS,
                    message: `Page copied to ${saveResponse.developerName}`,
                    isPersistent: false,
                }));
                PageActions.setEditingType(null, pageId);
            })
            .catch(({ message }) => {
                store.dispatch(addNotification({
                    type: notificationTypes.ERROR,
                    message,
                    isPersistent: false,
                }));
            });
    };

    const onCancel = () => {
        PageActions.setEditingType(null, page.id.value);
    };

    return (
        <div className="page-config" key="page-clone">
            <div>
                <h1>Copy page</h1>
                { isDirty ? (
                    <div role="alert" className="alert alert-warning">
                        <p><strong>Please save the page before making a copy.</strong></p>
                    </div>
                ) : null }
                <div className="form-group">
                    <label className="control-label">Name</label>
                    <input className="form-control" type="text" ref={nameInput} defaultValue={`${page.developerName.value} (copy)`} />
                </div>
                <div className="form-group">
                    <label className="control-label">Label</label>
                    <input className="form-control" type="text" ref={labelInput} defaultValue={page.label.value} />
                    <span className="help-block">The label will be displayed at the top of the page as a header</span>
                </div>
                <div className="form-group">
                    <label className="control-label">Summary</label>
                    <textarea className="form-control" type="textarea" ref={summaryInput} defaultValue={page.developerSummary.value} rows={3} />
                </div>
                <div className="page-config-footer">
                    <button className="btn btn-default btn-outline page-clone-cancel" onClick={onCancel}>Cancel</button>
                    <button className="btn btn-primary page-clone-save" disabled={isDirty} onClick={onSave}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default PageClone;
